import React, {Component} from 'react';

import Select from 'react-select';

import './FormUI.css';
import {Dropdown, Checkbox } from 'semantic-ui-react';
import Icon from './Icon';
import PersistentData from '../api/PersistentData';
import DatePicker from 'react-datepicker';
import moment from 'moment';


export class FormDataObj{
	formItems = {};

	constructor(data) {
		this.data = data || {};
	}
	registerFormItem(formItem){
		let itemName = formItem.props.name;
		this.formItems[itemName] = formItem;
		if(formItem.props.value != null && this.data[itemName] == null){
			this.data[itemName] = formItem.props.value;
		}else if(this.data[itemName] != null){
			formItem.state.value = this.data[itemName];
		}
		//console.log("ForItem Registered: " , itemName);

	}

	validate(){
		let invalid = [];

		for(let p in this.formItems){
			let item = this.formItems[p];
			//console.log("Validating: " + p + " = " + item.dataValue);
			if(!item.isValid() && item.props.required){
				invalid.push(item);
			}
		}
		return invalid;
	}

	getErrorState = () =>{
		let errors = this.validate();

		if(errors.length > 0){
			let err = {};
			for(let i=0; i < errors.length; i++){
				let item = errors[i];
				let itemName = item.props.name;
				err[itemName] = item.props.errorDesc || '*Required';
			}
			return err;
		}

		return null;
	}

	populateFormItems(){
		for(let p in this.formItems){
			let item = this.formItems[p];
			let value = this.data[item.props.name];
			item.setState({value:value});
		}
	}

	setValue(itemName, value){
		this.data[itemName] = value;
		let item = this.formItems[itemName];
		if(item){
			this.formItems[itemName].setState({value:value});
		}
	}

	getValue(itemName){
		return this.data[itemName];
	}

	static GetFormItemValue(formItem){
		let form = formItem.props.form;
		if(form === undefined)return null;

		let itemName = formItem.props.name;

		return form.data[itemName];

	}


}

export class FormItemBase extends Component{
	state = {};
	constructor(props){
		super(props);
		this.state.value = props.value;
		if(this.props.form){
			this.props.form.registerFormItem(this);
		}
		this.handleChange = this.handleChange.bind(this);
	}

	get dataObj(){
		if(this.props.form)return this.props.form.data || {};
		return this.props.dataObj || {};
	}

	get dataValue(){
		return this.dataObj[this.props.name];
	}

	set dataValue(val){
		this.dataObj[this.props.name] = val;
	}

	get value(){
		let val = this.props.form? this.dataValue: this.state.value;
		if(this.props.valueFormatter){
			val = this.props.valueFormatter(val);
		}
		return val;

		/*if(this.props.form)return this.dataValue;
		return this.state.value;*/
	}

	set value(val){
		this._onValueChanged(val);
	}



	isValid(){
		return (this.dataValue != null) && (this.dataValue != '');
	}




	/*componentWillReceiveProps(newProps){
		//console.log("Will recieve props.value:", newProps);
		this.__updateProps(newProps);
	}*/




	_updateDataObj(val){
		this.dataValue = this.props.formValueParser? this.props.formValueParser(val):val;
		/*if(this.props.dataObj && this.props.name){
			this.props.dataObj[this.props.name] = val;
		}*/
	}

	_cloneValue(val){
		let t = typeof(val);
		if(t == 'object' && val != null){
			return JSON.parse(JSON.stringify(val));
		}
		return val;
	}

	_onValueChanged = (val, ignoreChange) =>{
		//let oldValue = this._cloneValue(this.state.value);
		//console.log("onValue Change:", val)

		this._updateDataObj(val);
		this.setState({value:val});

		if(this.props.onChange && !ignoreChange){
			this.props.onChange(val);
		}
	}

	handleChange(e){
		this._onValueChanged(e.target.value);
	}
}

export class Input extends FormItemBase{

	componentDidMount(){
		this.forceUpdate();
		if(this.props.focus && this._input){
			this._input.focus();
		}
		console.log("Input["+ this.props.name + "] Form Value:", this.value)
	}

	handleOnKeyUp = (e) => {

		if(e.keyCode === 13 && this.props.onEnterPressed){
			this.props.onEnterPressed();
		}

		if(this.props.onKeyUp){
			this.props.onKeyUp(e);
		}
	}


	handleCompRef = (r) => {
		if(this.props.onDom){
			this.props.onDom(r, this);
		}
	}

	render(){
		let {value, onChange, dataObj, className, placeholder, ref, onFocus, onBlur, onKeyUp, error, form, onDom,  ...props} = this.props;
		let hasValue = this.state.value || (this._input? this._input.value:false) || this.value;
		let classList = (className || '').split(' ');

		classList.push('input');
		classList.push('form-ui-item');
		classList.push((hasValue) ? 'has-value':'no-value');


		if(this.state.focusState){
			classList.push(this.state.focusState);
		}

		if(this.props.error){
			classList.push('error');
		}

		if(this.props.required){
			classList.push('required');
		}

		if(!this.props.placeholder){
			classList.push('no-placeholder');
		}

		//console.log("Input .value:", this.state.value);



		return(
			<div className={classList.join(' ')} ref={this.handleCompRef}>
				<div className='error-status'>{this.props.error}</div>
				<div className='placeholder'>{this.props.placeholder}</div>
				<input
					value={this.value}
					onChange={this.handleChange}
					ref={(r) => {this._input = r}}
					onKeyUp = {this.handleOnKeyUp}
					onFocus={
						()=> {
							this.setState({focusState:'focused'});
							if(this.props.onFocus){
								this.props.onFocus.apply(null, arguments);
							}
						}
					}
					onBlur={
						()=> {
							this.setState({focusState:''});
							if(this.props.onBlur){
								this.props.onBlur.apply(null, arguments);
							}
						}
					}
					{...props}
				/>
				<div className='bottom-status'>{this.props.bottomStatus}</div>
				{(this.props.isBusy)?<span className="Select-loading"></span>:null}
			</div>
		);
	}
}

export class TextArea extends FormItemBase{
	render(){
		let {value , onChange, dataObj, form, error, ...props} = this.props;
		return(
			<div className='form-ui-item textarea'>
				<div className='error-status'>{this.props.error}</div>
				<textarea onChange={this.handleChange} value={this.state.value} ref={this.props.onDom} {...props} />
			</div>
		)
	}
}

export class CheckBox extends FormItemBase{
	handleChange(e, data){
		this._onValueChanged((this.props.radio)? data:data.checked);
	}
	render(){
		//console.log("Check Box: props.value:", this.props.value, '  state.value:', this.dataValue)
		let {onChange, dataObj, form, ...props} = this.props;
		return(
			<Checkbox onChange={this.handleChange} checked={(this.props.radio)? (this.props.value === this.dataValue):this.state.value} {...props} />
		)
	}
}

export class SelectList extends FormItemBase{
	constructor(props){
		super(props);

		if(props.memoryId){
			this.remember = new PersistentData('SelectListMemory');
			if(!this.state.value){
				this.state.value = this.remember.getData(props.memoryId);
				if(this.props.onChange && this.state.value){
					this.props.onChange(this.state.value);
				}
			}
		}

		this.updateValue = this.updateValue.bind(this);
		this.onRef = this.onRef.bind(this);

	}

	get memoryId(){
		if(this.props.memoryId){
			return this.props.memoryId;
		}
	}

	rememberSelection(val){
		if(this.memoryId){
			this.remember.setData(this.memoryId, val);
		}
	}

	recallSelection(){
		if(this.memoryId){
			let r = this.remember.getData(this.memoryId);
			if(this.props.onRecall){
				this.props.onRecall(r);
			}
			return r;
		}
	}

	updateValue(newValue){


		let labelKey = this.props.labelKey || 'label';
		let valueKey = this.props.valueKey || 'value';

		let v = (typeof(newValue) === 'object' && newValue != null)? newValue:{[valueKey]:newValue};

		let val = this.props.simpleValue? v[valueKey] : newValue;
		this.rememberSelection(val);
		this._onValueChanged(val);
		if(this.props.onChangeRaw){
			this.props.onChangeRaw(newValue);
		}
	}

	onRef(r){
		this._select = r;
	}

	get value(){
		if(!this._select)return {};
		return this._select._focusedOption;
	}

	componentWillReceiveProps(nextProp, nextContext){
		if(nextProp.value != this.props.value){

			//this._updateDataObj(nextProp.value);
			this.updateValue(nextProp.value);
		}
	}

	//<Dropdown options={this.props.options} ref={this.onRef} onChange={this.updateValue} value={this.state.value}  loading={this.props.isLoading} placeholder={this.props.placeholder} {...props} />


	render() {
		let {options, ref, onChange, onChangeRaw, value, isLoading, placeholder, isCreatable, isAsync, simpleValue, form,  ...props} = this.props;

		let CustomSelect = isCreatable? Select.Creatable : Select;

		if(isCreatable && isAsync){
			CustomSelect = Select.AsyncCreatable;
		}else if(isAsync){
			CustomSelect = Select.Async;
		}

		return (
			<div className='form-ui-item'>
				<div className='error-status'>{this.props.error}</div>
				<CustomSelect options={this.props.options} ref={this.onRef} onChange={this.updateValue} value={this.state.value}  isLoading={this.props.isLoading} placeholder={this.props.placeholder} inputProps={{autoComplete: 'OFF', autoCorrect: 'off', spellCheck: 'off' }} {...props} />
			</div>
		);
	}

}


export class FormLabeledItem extends Component{
	render(){
		return(
			<div className={'form-labeled-item ' + (this.props.className || '') + (this.props.parentItem ? ' parent-item':'' )} label={this.props.label}>
				<div className='label'>{this.props.label}</div>
				<div className='content'>{this.props.children}</div>
			</div>
		)
	}
}

export class Button extends Component{
	constructor(props){
		super(props);
		this.state = {caption: this.props.caption || "Button"};
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick(e){
		if(this.props.onClick){
			this.props.onClick(e);
		}
	}
	render(){
		let loadingAnim;
		if(this.props.isBusy){
			loadingAnim = <span className="Select-loading"></span>
		}
		let {value , onClick, dataObj, ...props} = this.props;
		return(
			<button className={this.props.className} onClick={this.handleClick}  {...this.state.attr} {...props}>
				{this.state.icon}<span>{this.props.caption}</span>{loadingAnim}
			</button>
		);
	}
}

export class ToggleButton extends Button{
	constructor(props){
		super(props);
		this.setToggle(this.props.toggle);
	}

	setToggle(toggle){
		let icon = toggle? this.props.onIcon:this.props.offIcon;
		let attr = this.state.attr || {};
		attr['toggle'] = toggle? 'on':'off';
		console.log('Attr Toggle:', attr)
		this.setState({
			icon:<Icon icon={icon} className='toggle-button-icon' />,
			toggle:toggle,
			attr:attr
		})
	}

	handleClick(e){
		super.handleClick(e);
		let toggle = !this.state.toggle
		this.setToggle(toggle);

		if(toggle && this.props.on){
			this.props.on();
		}else if(!toggle && this.props.off){
			this.props.off();
		}

		if(this.props.onToggle){
			this.props.onToggle(toggle);
		}
	}

	componentWillReceiveProps(newProps){
		if(newProps.toggle != null){
			this.setToggle(newProps.toggle);
		}
	}

}

export class ItemChooser extends FormItemBase{
	constructor(props){
		super(props);
		this.handleItemClick = this.handleItemClick.bind(this);
		//console.log("Item Chooser State:", this.state)
	}
	handleItemClick(id){
		if(this.props.disabled)return;
		let val = id;

		if(this.props.multi){
			//console.log('ItemChooser Value before:', id)
			let selectedItems = this.state.value || {};
			//console.log('ItemChooser Value selectedItems:', selectedItems)
			selectedItems[id] = !selectedItems[id];
			id = selectedItems;
		}

		// console.log('ItemChooser Value After:', id)

		this._onValueChanged(id);
	}

	drawIcons(){
		let icons = this.props.children;
		let items = [];
		for(let i=0; i < icons.length; i++){
			items.push(<ItemChooserItem item={icons[i]} onClick={this.handleItemClick} selected={this.state.value} multi={this.props.multi}  />);
		}
		return items;
	}

	render(){
		return(
			<div className={'item-chooser table align-middle align-center ' + (this.props.className || '')} onClick={this.props.onClick}>
				<div>{this.drawIcons()}</div>
			</div>
		)
	}
}

class ItemChooserItem extends Component{
	constructor(props){
		super(props);
		this.id = this.props.item.props.itemId || this.props.item.props.icon;
		this.handleItemClick = this.handleItemClick.bind(this);
		this.handleKeyPress = this.handleKeyPress.bind(this);
	}

	handleItemClick(){
		if(this.props.onClick){
			this.props.onClick(this.id);
		}
	}

	handleKeyPress(e){
		//console.log("Key Pressed:", e.charCode);
		if(e.charCode === 32){
			e.preventDefault();
			this.handleItemClick();
		}
	}

	render(){
		let selId = this.props.multi? (this.props.selected || {})[this.id] : this.props.selected;
		let isSelected = this.props.multi? (selId == true):(this.id == selId);
		let selected = (isSelected)? 'selected': '';


		return(
			<div className={selected} onClick={this.handleItemClick} onKeyPress={this.handleKeyPress} >{this.props.item}</div>

		)
	}
}

export class DateInputSelect extends FormItemBase{
	state = {};

	handleDateChange = (date) => {
		//console.log("handleDateChange:", moment(date).format("YYYY-MM-DD"))
		this._onValueChanged(moment(date).format(this.props.valueFormat || "YYYY-MM-DD"));
	}

	render(){
		let {form, name, isBusy, className, placeholder, error, required, ...props} = this.props;
		let date = moment(this.state.value).format(this.props.format || "YYYY-MM-DD");
		return(
			<DatePicker
				customInput={<span><Input isBusy={isBusy} className={className} value={date} placeholder={placeholder} error={error} required={required} /></span>}
				selected={moment(this.state.value)}
				onChange={this.handleDateChange}
				{...props}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/FormUI.js